import { Suspense } from 'react';

import { ClientMessageSender } from './client-message-sender';
import { ConsentDialogObserver } from './consent-dialog-observer';
import { TrackClickAttribution } from './track-click-attribution';
import { TrackFormAttribution } from './track-form-attribution';
import { TrackerQueue } from './tracker-queue';
import { TrackerScript } from './tracker-script';

import type { FC} from 'react';

export type TrackerProps = {
  // App-Based possibility to disable tracking
  disableTracking?: boolean;
};

export const Tracker: FC<TrackerProps> = props => {
  return (
    <Suspense>
      <TrackerScript disableTracking={props.disableTracking} />
      <TrackClickAttribution />
      <TrackFormAttribution />
      <TrackerQueue />
      <ClientMessageSender />
      <ConsentDialogObserver />
    </Suspense>
  );
};
